import WidgetList from "./WidgetList";
import ActionBar from "./ActionBar";
import { SelectValue } from "ui-kit/src/MultipleSelect/types";
import { GPGamePlayerResponse } from "../../types";
import { WidgetItem, InsightEventGroupEnum } from "./constants";
import { Loader2 } from "lucide-react";

interface InsightContentProps {
	activeTabWidgets: WidgetItem[];
	activeCategoryTab: InsightEventGroupEnum;
	activeGroupedEvents: Record<string, any>;
	activeCategoryEvents: any;
	periods: string[];
	filters: any[];
	allPlayers: Record<number, GPGamePlayerResponse>;
	showPlayerNumber: boolean;
	isLimitedVisualization: boolean;
	isPending: boolean;
	isContentPending: boolean;
	handleDeleteWidget: (identifier: string | number) => void;
	handleMapTypeChange: (identifier: string | number, mapType: any) => void;
	getEventsForCategory: (category: InsightEventGroupEnum) => any;
	onWidgetRef: (key: string, el: HTMLDivElement | null) => void;
	currentEventItems: SelectValue[];
	activeWidgetView: SelectValue | undefined;
	onNavigateToWidget: (selected: SelectValue) => void;
	onAddWidget: () => void;
	onResetDefault: () => void;
	onSaveView: () => void;
	isSavingView: boolean;
}

const InsightContent = ({
	activeTabWidgets,
	activeCategoryTab,
	activeGroupedEvents,
	activeCategoryEvents,
	periods,
	filters,
	allPlayers,
	showPlayerNumber,
	isLimitedVisualization,
	isPending,
	isContentPending,
	handleDeleteWidget,
	handleMapTypeChange,
	getEventsForCategory,
	onWidgetRef,
	currentEventItems,
	activeWidgetView,
	onNavigateToWidget,
	onAddWidget,
	onResetDefault,
	onSaveView,
	isSavingView,
}: InsightContentProps) => {
	return (
		<>
			<ActionBar
				onAddWidget={onAddWidget}
				onResetDefault={onResetDefault}
				currentEventItems={currentEventItems}
				activeWidgetView={activeWidgetView}
				onNavigateToWidget={onNavigateToWidget}
				onSaveView={onSaveView}
				isSavingView={isSavingView}
			/>

			<div className="widget-outer" style={{ position: "relative", minHeight: "200px" }}>
				{(isPending || isContentPending) && (
					<div
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							background: "rgba(255,255,255,0.7)",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							zIndex: 10,
						}}
					>
						<div
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								right: 0,
								height: "70vh",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								zIndex: 11,
							}}
						>
							<Loader2 className="animate-spin" size={32} />
						</div>
					</div>
				)}
				<WidgetList
					activeTabWidgets={activeTabWidgets}
					activeCategoryTab={activeCategoryTab}
					activeGroupedEvents={activeGroupedEvents}
					activeCategoryEvents={activeCategoryEvents}
					periods={periods}
					filters={filters}
					allPlayers={allPlayers}
					showPlayerNumber={showPlayerNumber}
					isLimitedVisualization={isLimitedVisualization}
					handleDeleteWidget={handleDeleteWidget}
					handleMapTypeChange={handleMapTypeChange}
					getEventsForCategory={getEventsForCategory}
					onWidgetRef={onWidgetRef}
				/>
			</div>
		</>
	);
};

export default InsightContent;
